<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Banks</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Bank</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Create Bank</h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label for="bankName" class="form-label">Bank Name</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" id="bankName" v-model="form.bankName"
                        placeholder="Enter bank name" required>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label for="bankCodeName" class="form-label">Bank Code</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" id="bankCodeName" v-model="form.bankCodeName"
                        placeholder="Enter bank code" required>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label for="bankSortCode" class="form-label">Sort Code</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" id="bankSortCode" v-model="form.bankSortCode"
                        placeholder="Enter sort code" required>
                    </div>
                  </div>

                </div>

                <div class="d-flex justify-content-center">
                  <button class="submit-btn" type="submit" :disabled="isLoading">
                    <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ isLoading ? 'Submitting...' : 'Submit' }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2'
import { onMounted } from 'vue'

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const isLoading = ref(false)

const form = reactive({
  bankName: '',
  bankCodeName: '',
  bankSortCode: '',
})

const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

const handleSubmit = async () => {
  const token = Cookies.get('auth_token')
  isLoading.value = true

  const bankData = {
    bankName: form.bankName.trim(),
    bankCodeName: form.bankCodeName.trim(),
    bankSortCode: form.bankSortCode.trim(),
  }

  try {
    const result = await axios.post(`${root_api_url}/payment/bank`, bankData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (result.status === 200) {
      Swal.fire({
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Bank Created Successfully</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      })
      form.bankName = ''
      form.bankCodeName = ''
      form.bankSortCode = ''
    }
  } catch (error) {
    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage ?? error?.response?.data?.error ?? 'Failed to create bank.'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      })
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred while creating bank. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      })
    }
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  document.title = 'Create Bank'
})
</script>

<style scoped>
.submit-btn {
  background-color: #3498db !important;
  border-color: #3498db !important;
}

.submit-btn:hover {
  background-color: #2980b9 !important;
  border-color: #2980b9 !important;
}
</style>
